import React, { useContext } from 'react'
import Select from '../select/Select'
import './planSelectPopup.css'
import PlansCard from './PlansCard';
import { appContext } from '../../service/AppContext';
import { registrationContex } from '../../service/RegisrationContext';
import Popup from '../popup/Popup';
import { ageOptions } from '../../service/inputUtil';
import { getAvailablePlans } from '../../service/planUtils';
import { ageToMonths } from '../../service/dateUtil';
import { familyTierPlans } from '../../service/familyPlanUtil';

export default function PlanSelectPopup({ closePopup, setPlan, age, setAge, name, preBorn, ageMonths, excludeRoutes = [], disabledAgeSelect = false, familyPlan = false }) {

    const { plans } = useContext(appContext);
    // Family plans & the family state live on the registration context (no provider in the simulator, where familyPlan=false)
    const registration = useContext(registrationContex);
    const familyPlans = registration?.familyPlans;

    // Standard availability is DB driven (minAgeMonths/maxAgeMonths) - fallback to selector age when no ageMonths passed
    const kidMonths = (ageMonths !== undefined && ageMonths !== null) ? ageMonths : ageToMonths(age, preBorn);
    // Family availability is tier driven: the children count the donor picked + the oldest child's age
    // ("no children yet" never asks the question -> 0 children)
    const filteredPlans = familyPlan
        ? familyTierPlans(familyPlans, (preBorn) ? 0 : registration?.familyChildrenCount, age)
        : getAvailablePlans(plans, kidMonths, excludeRoutes)

    const handleSetPlan = (plan) => {
        setPlan(plan?.route);
        closePopup();
    }

    return (
        <div  >
            <Popup closePopup={closePopup} >
                <div className='select-popup' >
                    <div className="title-wrapper">
                        <div role="heading" aria-level="2" className='heading-h3'>{familyPlan ? 'מסלולים בתוכנית המשפחתית' : <>מסלולים רלוונטים {!!(name) && 'עבור ' + name} לפי גיל</>}</div>
                    </div>
                    {(!familyPlan && (age <= 0.5  || preBorn)) && < Select className="child-age" name="child-age" label="גיל" value={ageOptions?.find(option => option.value >= age)?.value} options={ageOptions} onChange={setAge} locked={disabledAgeSelect} />}
                    {(familyPlan || age !== null) && <PlansCard plans={filteredPlans} handleSetPlan={handleSetPlan} age={age} familyPlan={familyPlan} />}
                </div>
            </Popup>
        </div>

    )
}
